import { useCallback, useEffect, useMemo, useState } from "react";
import { SoulDataModel } from "../../data/models/Soul/SoulDataModel";

export type Role = "USER" | "ADM" | string;

type LoadProfilesFn = () => Promise<SoulDataModel[]>;
type UpdateProfileFn = (changes: Partial<SoulDataModel>) => Promise<void>;

export function useAllProfile({
  loadProfiles,
  updateProfile,
}: {
  loadProfiles: LoadProfilesFn;
  updateProfile: UpdateProfileFn;
}) {
  const [profiles, setProfiles] = useState<SoulDataModel[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [editing, setEditing] = useState<SoulDataModel | null>(null);
  const [saving, setSaving] = useState<boolean>(false);
  const [query, setQuery] = useState<string>("");
  const [viewing, setViewing] = useState<SoulDataModel | null>(null); // para ver info/imagenes

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await loadProfiles();
      setProfiles(data);
    } finally {
      setLoading(false);
    }
  }, [loadProfiles]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return profiles;
    return profiles.filter((p) =>
      [p.fullName, p.document, p.emailOptional, p.role].some((v) =>
        (v ?? "").toLowerCase().includes(q)
      )
    );
  }, [profiles, query]);

  const openEdit = useCallback((p: SoulDataModel) => setEditing(p), []);
  const closeEdit = useCallback(() => setEditing(null), []);

  const openView = useCallback((p: SoulDataModel) => setViewing(p), []);
  const closeView = useCallback(() => setViewing(null), []);

  const saveEdit = useCallback(
    async (changes: Partial<SoulDataModel>) => {
      if (!editing) return;
      setSaving(true);
      try {
        await updateProfile(changes);
        refresh();
        // setProfiles((prev) =>
        //   prev.map((x) =>
        //     x.userId === editing.userId ? { ...x, ...changes } : x
        //   )
        // );
        setEditing(null);
      } finally {
        setSaving(false);
      }
    },
    [editing, updateProfile]
  );

  //   const toggleVerified = useCallback(
  //     async (p: SoulDataModel) => {
  //       const next = !p.isVerified;
  //       await updateProfile(p.userId!, { isVerified: next });
  //       setProfiles((prev) =>
  //         prev.map((x) => (x.userId === p.id ? { ...x, isVerified: next } : x))
  //       );
  //     },
  //     [updateProfile]
  //   );

  //   const toggleGuarantor = useCallback(
  //     async (p: SoulDataModel) => {
  //       const next = !p.isGuarantor;
  //       await updateProfile(p.id, { isGuarantor: next });
  //       setProfiles((prev) =>
  //         prev.map((x) => (x.id === p.id ? { ...x, isGuarantor: next } : x))
  //       );
  //     },
  //     [updateProfile]
  //   );

  return {
    // datos
    saveEdit,
    profiles: filtered,
    rawProfiles: profiles,
    loading,
    // búsqueda
    query,
    setQuery,
    // edición
    editing,
    openEdit,
    closeEdit,
    saving,
    // vista
    viewing,
    openView,
    closeView,
    // acciones
    // toggleVerified,
    // toggleGuarantor,
    // util
    refresh,
  };
}
